/**
 * Directive: card
 */
angular.module('acme.common.directive.card', [])
.directive('card', [function() {

    return {
      restrict: 'A',
      replace: true,
      transclude: true,
      templateUrl: 'common/directives/card/card.tpl.html',
      scope: {
        title: '@',
        description: '@',
        edit: '@',
        view: '@',
        remove: '@'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.card = "Your spankin new card!";

      }]

    };

}]);